<template>
  <div class="kye-upload-load" :style="cardStyle" :class="btnClass">
    <i class="el-icon-loading"></i>
    <span>上传中...</span>
  </div>
</template>

<script>
  export default {
    props: {
      areaSize: [Number, String, Array], // 宽*高
    },
    data () {
      return {}
    },
    computed: {
      cardStyle () {
        let s = this.$props.areaSize || 148
        if (!Array.isArray(s)) {
          s = [s, s]
        }
        return {
          'width': parseInt(s[0]) + 'px',
          'height': parseInt(s[1]) + 'px',
        }
      },
      isBigSize () {
        let s = this.$props.areaSize || 148
        if (Array.isArray(s)) {
          s = s[0]
        }
        return s >= 128
      },
      btnClass () {
        return {
          'is-big-size': this.isBigSize
        }
      },
    },
    methods: {}
  }
</script>

<style lang="scss">
  .kye-upload-load {
    margin-right: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--g-bg-gray);
    border: 2px dashed var(--g-border-color);
    border-radius: var(--g-border-radius);
    cursor: not-allowed;
    .el-icon-loading {
      font-size: 16px;
      margin-bottom: 4px;
      color: var(--g-color-primary);
    }
    span {
      color: #575561;
    }
    &.is-big-size {
      .el-icon-loading {
        font-size: 24px;
      }
      span {
        font-size: 14px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/public/components/kye-upload/components/upload-load.vue